import type {
  GetCustomerHierarchyObjectResponse,
  GetCustomerHierarchyResponse,
} from "../api/Customers";

export const mapHierarchyArrayToObject = (
  baseObject: GetCustomerHierarchyResponse,
  hierarchy: GetCustomerHierarchyResponse[]
) => {
  const root: GetCustomerHierarchyObjectResponse = {
    ...baseObject,
    children: [],
  };

  if (root.childrenCount > 0) {
    hierarchy.forEach((child) => {
      if (child.parentId === baseObject.id) {
        root.children.push(mapHierarchyArrayToObject(child, hierarchy));
      }
    });
  }

  return root;
};
